module.exports = __webpack_public_path__ + "img/project18_2.png.98f15994.webp";